import { render } from "./BpmnEvent.vue?vue&type=template&id=4b88781d&scoped=true"
import script from "./BpmnEvent.vue?vue&type=script&lang=js"
export * from "./BpmnEvent.vue?vue&type=script&lang=js"

import "./BpmnEvent.vue?vue&type=style&index=0&id=4b88781d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b88781d"]])

export default __exports__